export enum ConditionalElementState {
  Hidden = 'hidden',
  Visible = 'visible',
  Required = 'required',
}
